export const MODE_CHANGE_REQUEST = "MODE_CHANGE_REQUEST"
export const MODE_CHANGE_SUCCESS = "MODE_CHANGE_SUCCESS"
export const MODE_CHANGE_FAIL = "MODE_CHANGE_FAIL"
